import { render, staticRenderFns } from "./ContactTeamModal.vue?vue&type=template&id=3edb4798&"
import script from "./ContactTeamModal.vue?vue&type=script&lang=js&"
export * from "./ContactTeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3edb4798')) {
      api.createRecord('3edb4798', component.options)
    } else {
      api.reload('3edb4798', component.options)
    }
    module.hot.accept("./ContactTeamModal.vue?vue&type=template&id=3edb4798&", function () {
      api.rerender('3edb4798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/sidebar/modals/ContactTeamModal.vue"
export default component.exports